import React, { useState } from 'react';
import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../firebase';
import './RoleSelect.css';

const RoleSelect = ({ user, onComplete }) => {
	const [selectedRole, setSelectedRole] = useState(null);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);

	const handleSave = async () => {
		if (!selectedRole) {
			setError('Please choose a role to continue.');
			return;
		}
		try {
			setLoading(true);
			setError(null);
			const userRef = doc(db, 'users', user.uid);
			await updateDoc(userRef, { role: selectedRole });

			// Notify parent component about role completion
			// Parent (SignUp) will handle navigation based on role
			onComplete(selectedRole);
		} catch (e) {
			console.error('Error saving role:', e);
			setError('Failed to save role. Please try again.');
		} finally {
			setLoading(false);
		}
	};

	return (
		<div className="role-container">
			<div className="logo-section">
				<div className="logo-container">
					<span className="music-icon">🎵</span>
					<h1 className="logo-text">HubTune</h1>
				</div>
				<p className="tagline">Your Music Hub</p>
			</div>

			<div className="role-box">
				<h1 className="role-title">Choose Your Role</h1>
				<p className="role-subtitle">You can change this later in settings</p>
				{error && <div className="error-message">{error}</div>}

				<div className="role-grid">
					<button
						className={`role-card ${selectedRole === 'artist' ? 'active' : ''}`}
						onClick={() => setSelectedRole('artist')}
						type="button"
					>
						<div className="icon-circle">
							<span className="icon">🎤</span>
						</div>
						<h3 className="role-name">Artist</h3>
						<p className="role-desc">Upload tracks, build your audience.</p>
					</button>

					<button
						className={`role-card ${selectedRole === 'listener' ? 'active' : ''}`}
						onClick={() => setSelectedRole('listener')}
						type="button"
					>
						<div className="icon-circle">
							<span className="icon">🎧</span>
						</div>
						<h3 className="role-name">Listener</h3>
						<p className="role-desc">Discover music, follow artists.</p>
					</button>
				</div>

				<button className="submit-btn" onClick={handleSave} disabled={loading}>
					{loading ? 'Saving...' : 'Continue'}
				</button>
			</div>
		</div>
	);
};

export default RoleSelect;
